module.exports = __webpack_public_path__ + "img/face-grin-squint.f3b42d86.svg";